import React from "react";
import Moment from 'react-moment';
import 'moment/locale/es';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGlobe, faMapMarkerAlt, faCalendarAlt, faClock } from '@fortawesome/free-solid-svg-icons'


// import './Loader.scss'

export default function ShowTitle(props) {
    const { show, ...otherProps } = props

    // Date (no hour)
    const dateFormat = 'D [de] MMMM';
    const dateText = show.show_date ? <Moment local format={dateFormat}>{new Date(show.show_date)}</Moment> : '';
    // Hour and timezone/country
    let hourText = '';
    let timezoneText = '';
    if (show.show_date) {
        if (show.settings?.has_show_dates) {
            hourText = 'Múltiples Funciones';
        } else {
            const dateObj = new Date(show.show_date);
            hourText = dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
            timezoneText = show.timezone || show.country || '';
        }
    }
    // Venue
    const venueText = show.venue || '';
    const venueSub = show.venue_address || '';

    return (
        <div className="show-title-section show-title-section--tight">
            {Array.isArray(show.tags) && show.tags.length > 0 && (
                <div className="show-title-badges show-title-badges--tight">
                    {show.tags.map((tag, idx) => (
                        <span key={idx} className="show-badge show-badge--tight">{tag}</span>
                    ))}
                </div>
            )}
            <div className="show-title show-title--tight">{show.fullname}</div>
            {show.subtitle && <div className="show-title-subtitle show-title-subtitle--tight">{show.subtitle}</div>}
            <div className="show-title-info-cards show-title-info-cards--grid">
                <div className="show-title-info-card show-title-info-card--2col">
                    <div className="show-title-info-iconcol"><FontAwesomeIcon icon={faCalendarAlt} size="sm" /></div>
                    <div className="show-title-info-contentcol">
                        <div className="show-title-info-label">Fecha</div>
                        <div className="show-title-info-value">{dateText}</div>
                    </div>
                </div>
                <div className="show-title-info-card show-title-info-card--2col">
                    <div className="show-title-info-iconcol"><FontAwesomeIcon icon={faClock} size="sm" /></div>
                    <div className="show-title-info-contentcol">
                        <div className="show-title-info-label">Hora</div>
                        <div className="show-title-info-value">{hourText}</div>
                        {timezoneText && <div className="show-title-info-subvalue">{timezoneText}</div>}
                    </div>
                </div>
                <div className="show-title-info-card show-title-info-card--2col" style={{gridColumn: 'span 2'}}>
                    <div className="show-title-info-iconcol"><FontAwesomeIcon icon={faMapMarkerAlt} size="sm" /></div>
                    <div className="show-title-info-contentcol">
                        <div className="show-title-info-label">Lugar</div>
                        <div className="show-title-info-value">{venueText}</div>
                        {venueSub && <div className="show-title-info-subvalue">{venueSub}</div>}
                    </div>
                </div>
            </div>
        </div>    
    )
}